import React from "react";
import { NavLink } from "react-router-dom";

const DesktopAvatarMenu = (props) => {
  const toggleEditProfileImage = () => {
    if (props.AvatarImage.length < 1) {
      document.getElementById("profile-image").click();
    } else {
      props.ToggleAvatarEditor();
    }
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="desktop-avatar-menu closed" id="desktop-avatar-menu">
      <section>
        <span
          onClick={() =>
            document.getElementById("edit-profile-nav-link").click()
          }
        >
          <i className="feather-user"></i>
        </span>
        <p className="item-tooltip">{translateText("edit_profile")}</p>
      </section>
      <section>
        <span
          onClick={() => {
            window.localStorage.setItem("IsEditNotifications", 1);
            setTimeout(() => {
              document.getElementById("edit-profile-nav-link").click();
            }, 100);
          }}
        >
          <i className="feather-settings"></i>
        </span>
        <p className="item-tooltip">{translateText("edit_notifications")}</p>
      </section>
      <section
        id="edit-avatar-image-trigger"
        onClick={() => toggleEditProfileImage()}
      >
        <span>
          <i className="feather-camera"></i>
        </span>
        <p className="item-tooltip"> {translateText("edit_photo")} </p>
      </section>
    </div>
  );
};

export default DesktopAvatarMenu;
